


















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';

import { Typography, Surface } from '@/components/atoms';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import Arrow from '@/components/icons/Arrow.vue';
import HighlightCard from '@/componentsV2/molecules/HighlightCard/HighlightCard.vue';
import InfoIcon from '@/components/icons/Info.vue';

import { ICardPerformance } from '@/models/performance';
import { abbreviateNumber } from '@/utils/currency';
import segmentIo from '@/utils/segment.io';

type Config = {
  maxWidthDescription?: string;
  showFullNumber?: boolean;
};

export type HighlightContent = {
  key: string;
  title: string;
  description: string;
  actionLabel: string;
};

const defaultConfig = {
  maxWidthDescription: '100%'
};

@Component({
  components: {
    PoseTransition,
    Fade: posed.div({
      enter: {
        opacity: 1,
        transition: { duration: 200, delay: 400 }
      },
      exit: {
        opacity: 0,
        transition: { duration: 200 }
      }
    }),
    Typography,
    Surface,
    GhostButton,
    Arrow,
    HighlightCard,
    InfoIcon
  }
})
export default class PerformanceItem extends Vue {
  @Prop({ required: true, default: () => {} }) performance!: ICardPerformance;
  @Prop({ default: () => defaultConfig }) config?: Config;
  @Prop({ default: 0 }) counterFractionDigits?: number;
  @Prop({ default: '' }) gaEventCategory?: string;
  @Prop({ default: false }) highlighted?: boolean;
  @Prop() highlightContent?: HighlightContent;
  @Prop({ default: false }) showInfoIcon?: boolean;
  @Prop({ default: '' }) infoIconTooltip?: string;
  @Prop() actionLabel?: string;

  handleHighlightOnEdit(highlightKey: string) {
    if (this.highlighted) {
      segmentIo.track('Clicked Inactive Cunsumers Hover', { Label: 'Edit' });
    }

    this.$emit('highlight-action-click', highlightKey);
  }

  handleHighlightOnClose() {
    this.$emit('highlight-close-click');

    segmentIo.track('Clicked Inactive Cunsumers Hover', { Label: 'Close' });
  }

  goTo() {
    if (this.performance.link) {
      if (this.gaEventCategory) {
        this.$analytics({
          eventCategory: this.gaEventCategory,
          eventLabel: `Clicked on the "${this.performance.linkLabel}" button`,
          eventAction: 'click'
        });
      }

      this.$emit('goTo', this.performance.link);
      this.$router.push(this.performance.link);
    }
  }

  get configOptions() {
    return Object.assign({}, defaultConfig, this.config);
  }

  get counter() {
    if (this.configOptions.showFullNumber) {
      if (this.performance.formattedCounter)
        return this.performance.formattedCounter;
      return this.performance.counter;
    }

    return abbreviateNumber(
      this.performance.counter,
      this.counterFractionDigits
    );
  }

  get iconURL() {
    if (!this.performance.icon) return null;

    return require(`@/assets/img/performance/${this.performance.icon}.svg`);
  }

  get descriptionStyle() {
    return {
      '--performance-item-max-width-description': this.configOptions
        .maxWidthDescription
    };
  }

  get mobileTooltipStyle() {
    const element = document.querySelector(
      `[data-tippy=${this.highlightContent && this.highlightContent.key}]`
    );

    if (!element) {
      return {
        display: 'none'
      };
    }

    const { top } = element.getBoundingClientRect();

    return {
      left: '24px',
      top: `${top + 278 + 190}px`
    };
  }
}
